export default function zeroEmpty() {
  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $ngModel.$parsers.unshift((viewValue) => {
        if (!viewValue) {
          return 0;
        }

        return viewValue;
      });

      $ngModel.$formatters.unshift((modelValue) => {
        if (String(modelValue) === '0') {
          return null;
        }

        return modelValue;
      });
    },
  };
}
